import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { SetIsWidgetActive, ToggleModal } from '../../types';
import openModalByError from '../../utils/open-modal-by-error';

type UseOpenPanelOnErrorParams = {
  toggleModal: ToggleModal;
  setIsWidgetActive: SetIsWidgetActive;
};

const UseOpenPanelOnError = ({ toggleModal, setIsWidgetActive }: UseOpenPanelOnErrorParams) => {
  const { errors, isValid, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValid) {
      openModalByError({ errors, setIsWidgetActive, toggleModal });
    }
  }, [isValid, isSubmitting]);
};

export default UseOpenPanelOnError;
